// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --title_red: #b31b1b;
  --background_color: #f0f2f5;
  --background_color_mob: #fff;
  --wrap_bg_color: #fff;
  --wrap_color: #000;
  --unseen-paper-bg: #daf3ff;
  --unseen-border-color: #c1c1c1;
  --unseen-hover-bg: #c5e8fa;
  --seen-hover-bg: #f6f4f4;
  --border_curv: 10px;
  --menu_width: 200px;
  --menu_content_bg: #fff;
  --menu_title_color: var(--wrap_color);
  --menu_item_color: #666;
  --menu_item_hover_color: #222;
  --bm-item-color: #444;
  --bm-item-hover-color: #000;
  --navlink-bg-color: #007bff;
  --navlink-color: #007bff;
  --navlink-color-hover: #001f79;
  --navlink-bg-hover: #ebf5ff;
  --navlink-color-active: #fff;
  --doi-label-color: #f5f5f5;
  --doi-label-bg: #2d2d2d;
  --doi-number-color: #000;
  --doi-number-bg: #f5f5f5;
  --tag_panel_color: #000;
  --tag_border_color: #000;
  --btn-primary-bg-color: #007bff;
  --btn-primary-border-color: #007bff;
  --btn-primary-color: #fff;
  --btn-primary-bg-color-hover: #0069d9;
  --btn-primary-border-color-hover: #0062cc;
  --btn-primary-color-hover: #fff;
  --selector-bg: #fff;
  --selector-color: #495057;
  --pagination-bg: #fff;
  --pagination-color: #007bff;
  --pagination-border: #dee2e6;
  --pagination-bg-hover: #e9ecef;
  --pagination-color-hover: #0056b3;
  --pagination-border-hover: #dee2e6;
  --pagination-bg-active: #007bff;
  --pagination-color-active: #fff;
  --pagination-border-active: #007bff;
  --pagination-na-bg: #fff;
  --pagination-na-color: #6c757d;
  --popup-bg: var(--wrap_bg_color);
  --popup-border: #909090;
  --popup-font: #000;
}
`, "",{"version":3,"sources":["webpack://./less/vars.less"],"names":[],"mappings":"AAAA;EAEE,oBAAA;EACA,2BAAA;EACA,4BAAA;EAEA,qBAAA;EACA,kBAAA;EAGA,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,wBAAA;EAGA,mBAAA;EACA,mBAAA;EAEA,uBAAA;EACA,qCAAA;EACA,uBAAA;EACA,6BAAA;EACA,qBAAA;EACA,2BAAA;EAEA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,2BAAA;EACA,4BAAA;EAGA,0BAAA;EACA,uBAAA;EACA,wBAAA;EACA,wBAAA;EAEA,uBAAA;EACA,wBAAA;EAGA,+BAAA;EACA,mCAAA;EACA,yBAAA;EAEA,qCAAA;EACA,yCAAA;EACA,+BAAA;EAGA,mBAAA;EACA,yBAAA;EAGA,qBAAA;EACA,2BAAA;EACA,4BAAA;EAEA,8BAAA;EACA,iCAAA;EACA,kCAAA;EAEA,+BAAA;EACA,+BAAA;EACA,mCAAA;EAEA,wBAAA;EACA,8BAAA;EAEA,gCAAA;EACA,uBAAA;EACA,kBAAA;AArBF","sourcesContent":[":root {\n  // general\n  --title_red: #b31b1b;\n  --background_color: #f0f2f5;\n  --background_color_mob: #fff;\n  // wrapper\n  --wrap_bg_color: #fff;\n  --wrap_color: #000;\n\n  // paper land recent submissions\n  --unseen-paper-bg: #daf3ff;\n  --unseen-border-color: #c1c1c1;\n  --unseen-hover-bg: #c5e8fa;\n  --seen-hover-bg: #f6f4f4;\n\n  // menu\n  --border_curv: 10px;\n  --menu_width: 200px;\n  // menu colors\n  --menu_content_bg: #fff;\n  --menu_title_color: var(--wrap_color);\n  --menu_item_color: #666;\n  --menu_item_hover_color: #222;\n  --bm-item-color: #444;\n  --bm-item-hover-color: #000;\n\n  --navlink-bg-color: #007bff;\n  --navlink-color: #007bff;\n  --navlink-color-hover: #001f79;\n  --navlink-bg-hover: #ebf5ff;\n  --navlink-color-active: #fff;\n\n  // paper\n  --doi-label-color: #f5f5f5;\n  --doi-label-bg: #2d2d2d;\n  --doi-number-color: #000;\n  --doi-number-bg: #f5f5f5;\n  // tag color\n  --tag_panel_color: #000;\n  --tag_border_color: #000;\n\n  // buttons\n  --btn-primary-bg-color: #007bff;\n  --btn-primary-border-color: #007bff;\n  --btn-primary-color: #fff;\n\n  --btn-primary-bg-color-hover: #0069d9;\n  --btn-primary-border-color-hover: #0062cc;\n  --btn-primary-color-hover: #fff;\n\n  // sorting selector at the top of paper page\n  --selector-bg: #fff;\n  --selector-color: #495057;\n\n  // pagination\n  --pagination-bg: #fff;\n  --pagination-color: #007bff;\n  --pagination-border: #dee2e6;\n\n  --pagination-bg-hover: #e9ecef;\n  --pagination-color-hover: #0056b3;\n  --pagination-border-hover: #dee2e6;\n\n  --pagination-bg-active: #007bff;\n  --pagination-color-active: #fff;\n  --pagination-border-active: #007bff;\n\n  --pagination-na-bg: #fff;\n  --pagination-na-color: #6c757d;\n\n  --popup-bg: var(--wrap_bg_color);\n  --popup-border: #909090;\n  --popup-font: #000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
